import * as notifier from "../common/ErrorsNotification";
import {setLastServerLog} from "../common/ErrorsNotification";
import * as NaMaErrors from "../constants/NaMaErrors";
import {isArabic, translateId} from "./Translator";
import * as app from "../views/mainapp";
import {currentUserId} from "../login/LoginPresenter";
import {logout} from "../login/Security";
import {getCustomGUISettings, isServerLogActive} from "../login/ClientCache";
import * as cookies from 'js-cookie'
import * as urls from "../constants/NamaURLS";
import * as GUIDevMode from "../constants/GUIDevMode";
import WaitIndicatorTemplate from "../compiled-templates/WaitIndicatorTemplate";

let tasksCount = 0;

export function addTask() {
    tasksCount++;
}

export function removeTask() {
    tasksCount--;
}

export function busy() {
    if (tasksCount > 0)
        return true;
    return false;
}

let beforeUnloadListeners = [];

export function addBeforeUnloadListener(listener) {
    beforeUnloadListeners.push(listener);
}

export function removeBeforeUnloadListener(listener) {
    let index = beforeUnloadListeners.indexOf(listener);
    if (index < 0)
        return;
    delete beforeUnloadListeners[index];
}

export function initWindowOnBeforeUnload() {
    window.onbeforeunload = function (e) {
        for (let listener of beforeUnloadListeners) {
            if (!listener)
                continue;
            if (listener.destroyed)
                continue;
            let hasChanges = listener(e);
            if (hasChanges)
                return hasChanges;
        }
        return null;
    }
}
export function addNamaExtenstionsToPrototypes() {
    let comboOldKeyDown = kendo.ui.ComboBox.fn._keydown;
    kendo.ui.ComboBox.fn._keydown = function (e) {
        let key = e.keyCode;
        if (key == kendo.keys.ESC) {
            this.input.attr("escClicked", true);
        } else {
            this.input.removeAttr("escClicked");
        }
        comboOldKeyDown.apply(this, arguments);
    };
    window.translateId = translateId
    window.onLocPickerClose = function () {
        if (window.lastLocationPickerField) {
            window.lastLocationPickerField.onLocationPicked(window.selectedLocation, window.selectedAddress);
        }
    };
    String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
    };
    String.prototype.contains = function (search) {
        return this.indexOf(search) >= 0;
    };
    String.prototype.equalsIgnoreCase = function (another) {
        return this.toLowerCase() === (another.toLowerCase() || "");
    };
    jQuery.fn.tagName = function () {
        return this.prop("tagName");
    };
    jQuery.fn.nextCousin = function () {
        return this.parent().next().children(this.tagName() + ":eq(" + this.index() + ")");
    }
    /**
     * @function
     * @param el
     * @param compare_fn
     * @return {number}
     */
    Array.prototype.binarySearch = function (el, compare_fn = namaCompare) {
        return binarySearch(this, el, compare_fn)
    };
    Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
    };
    Array.prototype.removeAll = function (elements) {
        for (let element of elements) {
            let index = this.indexOf(element);
            if (index > -1)
                this.splice(index, 1);
        }
        return this;
    };
    /**
     * @function
     * @param el
     * @param compare_fn
     * @return {number}
     */
    Array.prototype.binaryIndexOf = function (el, compare_fn = namaCompare) {
        return binarySearch(this, el, compare_fn)
    }
    /**
     * @function
     * @param {*} el
     * @param {function(T=, T=, Array.<T>=)} compare_fn
     * @return {boolean}
     */
    Array.prototype.binaryContains = function (el, compare_fn = namaCompare) {
        return binarySearch(this, el, compare_fn) >= 0
    }

    /**
     * @function
     * @param {*} el
     * @return {boolean}
     */
    Array.prototype.contains = function (el) {
        return this.indexOf(el) >= 0
    }

    kendo.ui.FilterMenu.fn.options.operators = {
        "string": {
            "contains": "Contains",
            "eq": "Is equal to",
            "neq": "Is not equal to",
            "startswith": "Starts with",
            "doesnotcontain": "Does not contain",
            "endswith": "Ends with",
            "isnull": "Is null",
            "isnotnull": "Is not null",
            "isempty": "Is empty",
            "isnotempty": "Is not empty"
        },
        "number": {
            "eq": "Is equal to",
            "neq": "Is not equal to",
            "gte": "Is greater than or equal to",
            "gt": "Is greater than",
            "lte": "Is less than or equal to",
            "lt": "Is less than",
            "isnull": "Is null",
            "isnotnull": "Is not null"
        },
        "date": {
            "eq": "Is equal to",
            "neq": "Is not equal to",
            "gte": "Is after or equal to",
            "gt": "Is after",
            "lte": "Is before or equal to",
            "lt": "Is before",
            "isnull": "Is null",
            "isnotnull": "Is not null"
        },
        "enums": {"eq": "Is equal to", "neq": "Is not equal to", "isnull": "Is null", "isnotnull": "Is not null"}
    }
}

export function substringBefore(str, separator) {
    if (!str || !separator) {
        return str;
    }
    if (!separator.length) {
        return "";
    }
    let pos = str.indexOf(separator);
    if (pos == -1) {
        return str;
    }
    return str.substring(0, pos);
}

export function substringAfter(str, separator) {
    if (!str || !separator) {
        return str;
    }
    if (!separator.length) {
        return "";
    }
    let pos = str.indexOf(separator);
    if (pos == -1) {
        return "";
    }
    return str.substring(pos + separator.length);
}

export function ajaxJSON(url, request, callback, failureCallback, owner, isJsonReq) {
    return _ajaxJSON(true, true, url, request, callback, failureCallback, owner, false, isJsonReq);
}

export function ajaxJSONWithoutWait(url, request, callback, failureCallback, isJsonReq) {
    return _ajaxJSON(true, false, url, request, callback, failureCallback, false, isJsonReq);
}

export function ajaxJSONWithoutError(url, request, callback, failureCallback, isJsonReq) {
    return _ajaxJSON(false, true, url, request, callback, failureCallback, false, isJsonReq);
}

export function ajaxJSONWithTask(url, request, callback, failureCallback, owner, isJsonReq) {
    return _ajaxJSON(true, true, url, request, callback, failureCallback, owner, true, isJsonReq);
}

function _ajaxJSON(handleErrors, showWait, url, request, callback, failureCallback, owner, startTask, isJsonReq) {
    let call = _ajaxJSON1(handleErrors, showWait, url, request, callback, failureCallback, owner, startTask, isJsonReq);
    call.then(() => {
        if (showWait)
            removeWait();
    }).fail(() => {
        if (showWait)
            removeWait();
    });
    return call;
}

function isWarning(result) {
    return result && result.warning;
}

export function requestToUrlString(request) {
    let data = "";
    let index = 0;
    for (const key in request) {
        if (index > 0)
            data += "&";
        data += encodeURIComponent(key) + "=" + encodeURIComponent(request[key]);
        index++;
    }
    return data;
}


function _ajaxJSON1(handleErrors, showWait, url, request, callback, failureCallback, owner, startTask, isJsonReq) {
    url = GUIDevMode.APP_URL + url;
    let dataType = 'json';
    if (request && request.ajaxRequestDataType)
        dataType = request.ajaxRequestDataType;
    if (request instanceof Object && !request.beforeLogin) {
        addCommonParametersToRequest(request);
    }
    if (showWait)
        addWait();
    if (startTask)
        addTask();
    let isAsync = true;
    if(request.notAsync)
        isAsync = false;
    let settings = {
        type: 'post',
        url: url,
        dataType: dataType,
        contentType: request.contentType,
        authorization: request.authorization,
        crossDomain: true,
        async: isAsync,
        data: request.actualData ? request.actualData : request,
        success: (args) => {
            let result = args;
            if (args && args.result)
                result = args.result;
            if (startTask)
                removeTask();
            if (isFailure(result)) {
                if (handleErrors)
                    handleFailure(result, owner);
                if (failureCallback)
                    failureCallback(result);
            } else {
                if (isWarning(result))
                    notifier.showWarnings(result.errors);
                if (callback)
                    callback(args);
            }
        },
        error: (...args) => {
            if (startTask)
                removeTask();
            if (handleErrors)
                showErrors(args);
            if (failureCallback)
                failureCallback(args);
        },
        fail: (...args) => {
            if (startTask)
                removeTask();
            showErrors(args);
            if (failureCallback)
                failureCallback(args);
        }
    };
    if (isJsonReq)
        settings['contentType'] = 'application/json';
    return $.ajax(settings);
}

export function addCommonParametersToRequest(request) {
    if (request && app.instance.loginInfo) {
        if (!request.uId)
            request.uId = currentUserId();
        if (!request.lId && app.instance.loginInfo && app.instance.loginInfo.userInfo)
            request.lId = app.instance.loginInfo.userInfo.loginId;

        if (request.inChangeDimsDialog) {
            request.leg = app.instance.loginInfo.userInfo.legalEntity.id;
            request.sc = app.instance.loginInfo.userInfo.sector.id;
            request.br = app.instance.loginInfo.userInfo.branch.id;
            request.dep = app.instance.loginInfo.userInfo.department.id;
            request.an = app.instance.loginInfo.userInfo.analysisSet.id;
        } else {
            request.leg = app.instance.loginInfo.dimensions.legalEntity ? app.instance.loginInfo.dimensions.legalEntity.id : null;
            request.sc = app.instance.loginInfo.dimensions.sector ? app.instance.loginInfo.dimensions.sector.id : null;
            request.br = app.instance.loginInfo.dimensions.branch ? app.instance.loginInfo.dimensions.branch.id : null;
            request.dep = app.instance.loginInfo.dimensions.department ? app.instance.loginInfo.dimensions.department.id : null;
            request.an = app.instance.loginInfo.dimensions.analysisSet ? app.instance.loginInfo.dimensions.analysisSet.id : null;
        }
    }
    request.trackLogs = isServerLogActive() || "";
}

function showErrors(args) {
    console.log(args);
    setLastServerLog(args);
}

function handleFailure(result, owner) {
    if (areEqual(result.errorType, "ConnectionError")) {
        notifier.showError(translateId("couldNotConnectToServer"));
        return;
    }

    setLastServerLog(result);
    if (areEqual(result.errorType, NaMaErrors.AUTHENTICATION_ERROR)) {
        if (isEmptyOrNull(cookies.get("dmsdeviceid"))) {
            notifier.showErrors(result.errors, owner);
            logout();
            return;
        }
        tryReLogin();
        return;
    }
    notifier.showErrors(result.errors, owner);
}

function tryReLogin() {
    let loginInfo =
        {
            deviceId: cookies.get("dmsdeviceid"),
        };
    ajaxJSON(urls.LOGIN, {
            loginInfo: JSON.stringify(loginInfo)
        }, () => {
        }, () => {
            logout();
        }
    );
}

function isFailure(result) {
    return result && result.failureOccurred;
}

let waits = 0;

export function addWait() {
    waits++;
    setTimeout(() => {
        addWaitImmediate(true);
    }, 100)

}

export function addWaitImmediate(doNotIncrement) {
    if (!doNotIncrement)
        waits++;
    if (waits <= 0)
        return;
    let currentIndicator = $("#Loading-Message");
    let msg = "Please wait...";
    if (isArabic())
        msg = "برجاء الانتظار...";
    if (!currentIndicator.length)
        $(`body`).append(WaitIndicatorTemplate({msg: msg, dir: isArabic() ? "rtl" : "ltr"}));
}
export function removeWait() {
    waits--;
    setTimeout(() => {
        if (waits < 0) waits = 0;
        if (waits === 0) {
            $("#spiner").fadeOut(50, function () {
                $("#Loading-Message").remove();
            });
            $("body").css("overflow-y", "auto");
        }
    },50);
}

export function fieldValue(object, fieldId, row) {
    if (!fieldId)
        return object;
    if (isNullOrUndefined(object))
        return object;
    let parts = fieldId.split(".");
    let current = object;
    for (let part of parts) {
        current = current[part];
        if (row !== undefined && row !== -1 && Array.isArray(current))
            current = current[row];
        if (isNullOrUndefined(current))
            return current;
    }
    return current;
}

export function setFieldValue(object, fieldId, value, row) {
    if (!fieldId)
        return;
    if (isNullOrUndefined(object))
        return;
    let parts = fieldId.split(".");
    let current = object;
    for (let i = 0; i < parts.length - 1; i++) {
        let part = parts[i];
        let parent = current;
        current = parent[part];
        if (row !== undefined && row !== -1 && Array.isArray(current))
            current = current[row];
        if (isNullOrUndefined(current))
            parent[part] = current = {};
    }
    if (Array.isArray(current)) {
        for (let line of current)
            line[parts[parts.length - 1]] = value;
    } else {
        current[parts[parts.length - 1]] = value;
    }
    return current;
}

let next = 1;

export function nextId() {
    return "id" + (next++);
}

export function namaCompare(o1 = null, o2 = null) {
    if (o1 === o2)
        return 0;
    if (o1 > o2)
        return 1;
    if (o1 < o2)
        return -1;
    if (o1 === null)
        return -1;
    if (o2 == null)
        return 1;
    if (o1.id || o2.id)
        return namaCompare(o1.id, o2.id)
    return namaCompare(o1.toString(), o2.toString());
}

export function binarySearch(ar, el, compare_fn) {
    var m = 0;
    var n = ar.length - 1;
    while (m <= n) {
        var k = (n + m) >> 1;
        var cmp = compare_fn(el, ar[k]);
        if (cmp > 0) {
            m = k + 1;
        } else if (cmp < 0) {
            n = k - 1;
        } else {
            return k;
        }
    }
    return -m - 1;
}

export function isAnyEqualToFirst(first, ...args) {
    for (let arg of args)
        if (areEqual(first, arg))
            return true;
    return false;
}

export function areEqual(o1, o2) {
    if (o1 === o2)
        return true;
    if (o1 && o2) {
        if (o1.id || o2.id)
            return o1.id === o2.id;
        if (o1.empty && o2.empty)
            return true;
    }
    return JSON.stringify(o1) === JSON.stringify(o2);
}

export function areNotEqual(o1, o2) {
    return !areEqual(o1, o2);
}

export function isAnyEmptyOrNull(...args) {
    for (let arg of args) {
        if (isEmptyOrNull(arg))
            return true;
    }
    return false;
}

export function isNotEmptyOrNull(o) {
    return !isEmptyOrNull(o);
}

export function getFirstNotEmptyObj(...args) {
    for (let arg of args)
        if (isNotEmptyOrNull(arg))
            return arg;
    return getFirstNotNullObj(...args);
}

export function getFirstNotNullObj(...args) {
    for (let arg of args)
        if (!(isNullOrUndefined(arg)))
            return arg;
    return null;
}

export function isEmptyOrNull(o) {
    if (!o)
        return true;
    if (o.length !== undefined && o.length === 0)
        return true;
    return false;
}

export function isNullOrUndefined(o) {
    if (o === undefined)
        return true;
    if (o === null)
        return true;
    return false;
}

export function areAllEmptyOrNull(...args) {
    for (let arg of args) {
        if (isNotEmptyOrNull(arg))
            return false;
    }
    return true;
}

let elementsWithResizeHandler = new Map();
let DOMNodeRemovedRegistered = false;
let windowOnResizeRegistered = false;

/**
 *
 * @param {HTMLElement} element
 * @param @callback onResize
 */
export function registerOnWindowResize(element, onResize) {
    registerDOMNodeRemoved();
    registerWindowOnResize();
    elementsWithResizeHandler.set(element, onResize);
}

function registerDOMNodeRemoved() {
    if (DOMNodeRemovedRegistered)
        return;
    $(document).bind("DOMNodeRemoved", function (e) {
        elementsWithResizeHandler.delete(e.target);
    });
}

function registerWindowOnResize() {
    if (windowOnResizeRegistered)
        return;
    $(window).on("resize", function (e) {
        for (let [key, callback] of elementsWithResizeHandler.entries()) {
            callback(e);
        }
    })
}

export function fetchURL(strUrl) {
    let strReturn = "";
    $.ajax({
        url: strUrl,
        success: function (html) {
            strReturn = html;
        },
        async: false
    });
    return strReturn;
}

export function getCustomerSupportEndDate() {
    try {
        return fetchURL(
            "https://namasoft.com/nlm/cmods?fetchexpirydate=" + getCustomGUISettings().tooltipsAndReportsAndRevise.customerName);
    } catch (e) {
        return "Could not connect";
    }
}

export function getLicenceDetails() {
    try {
        let ss = getCustomGUISettings().tooltipsAndReportsAndRevise.subServer;
        ss = ss ? ss : "";
        return fetchURL(
            "https://namasoft.com/nlm/cmods?fetchlecount=" + getCustomGUISettings().tooltipsAndReportsAndRevise.customerName + "&ss=" + ss);
    } catch (e) {
        return "Could not connect";
    }
}

export function getCustomerSupportAlertPeriod() {
    try {
        let value = fetchURL(
            "https://namasoft.com/nlm/cmods?fetchalertperiod=" + getCustomGUISettings().tooltipsAndReportsAndRevise.customerName);
        return value || 25;
    } catch (e) {
        return 25;
    }
}

export function isAnyTrue(...args) {
    for (let arg of args)
        if (arg === true)
            return true;
    return false;
}

export function noMenu() {
    return localStorage.getItem("noMenu") === "true";
}

let profilers = new Map();

export function startProfiler(id) {
    profilers.set(id, Date.now());
}

export function endProfiler(id) {
    let start = profilers.get(id);
    if (!start) {
        console.error("You did not start the profiler " + id);
        return;
    }
    let end = Date.now();
    console.log(id + " took " + (end - start) + " ms");
    profilers.delete(id);
}